module.exports = __webpack_public_path__ + "img/9788957983218.a21e5609.jpg";